export interface TrajectoryPlotSelection {
  include3D: boolean;
  includeNorthing: boolean;
  includeEasting: boolean;
  includePlanView: boolean;
  includeDoglegSeverity: boolean;
}

export interface PeriformInputsReportOptions {
  includeWellConfigSummary: boolean;
  includeStringSectionDetails: boolean;
  includeAnnulusContents: boolean;
  includeCementingLanding: boolean;
  includePackers: boolean;
  includeExpansionJoints: boolean;
  includeTrajectory: boolean;
  includeTrajectoryTable: boolean;
  trajectoryPlots: TrajectoryPlotSelection;
  includeUdt: boolean;
  includeUdtTable: boolean;
  includeFormationTops: boolean;
  includeFormationTopsTable: boolean;
  includeFluidsSummaryTable: boolean;
  includeDrillstringsTable: boolean;
  includeWellSchematic: boolean;
}

export class PeriformInputsReportPresets {
  static readonly TrajectoryPlotsAll: TrajectoryPlotSelection = {
    include3D: true,
    includeNorthing: true,
    includeEasting: true,
    includePlanView: true,
    includeDoglegSeverity: true
  };

  static readonly TrajectoryPlotsThreeDOnly: TrajectoryPlotSelection = {
    include3D: true,
    includeNorthing: false,
    includeEasting: false,
    includePlanView: false,
    includeDoglegSeverity: false
  };

  static readonly Default: PeriformInputsReportOptions = {
    includeWellConfigSummary: false,
    includeStringSectionDetails: false,
    includeAnnulusContents: false,
    includeCementingLanding: false,
    includePackers: false,
    includeExpansionJoints: false,
    includeTrajectory: false,
    includeTrajectoryTable: false,
    trajectoryPlots: { ...PeriformInputsReportPresets.TrajectoryPlotsAll },
    includeUdt: false,
    includeUdtTable: false,
    includeFormationTops: false,
    includeFormationTopsTable: false,
    includeFluidsSummaryTable: false,
    includeDrillstringsTable: false,
    includeWellSchematic: false
  };

  static readonly None: PeriformInputsReportOptions = {
    ...PeriformInputsReportPresets.Default,
    trajectoryPlots: { ...PeriformInputsReportPresets.TrajectoryPlotsAll }
  };

  static readonly All: PeriformInputsReportOptions = {
    includeWellConfigSummary: true,
    includeStringSectionDetails: true,
    includeAnnulusContents: true,
    includeCementingLanding: true,
    includePackers: true,
    includeExpansionJoints: true,
    includeTrajectory: true,
    includeTrajectoryTable: true,
    trajectoryPlots: { ...PeriformInputsReportPresets.TrajectoryPlotsAll },
    includeUdt: true,
    includeUdtTable: true,
    includeFormationTops: true,
    includeFormationTopsTable: true,
    includeFluidsSummaryTable: true,
    includeDrillstringsTable: true,
    includeWellSchematic: true
  };
}

export function validateReportOptions(options: PeriformInputsReportOptions): string[] {
  const errors: string[] = [];

  const hasAnySelection =
    options.includeWellConfigSummary ||
    options.includeStringSectionDetails ||
    options.includeAnnulusContents ||
    options.includeCementingLanding ||
    options.includePackers ||
    options.includeExpansionJoints ||
    options.includeTrajectory ||
    options.includeTrajectoryTable ||
    options.includeUdt ||
    options.includeUdtTable ||
    options.includeFormationTops ||
    options.includeFormationTopsTable ||
    options.includeFluidsSummaryTable ||
    options.includeDrillstringsTable ||
    options.includeWellSchematic;

  if (!hasAnySelection) {
    errors.push('At least one section must be selected');
  }

  const hasAnyTrajectoryPlot =
    options.trajectoryPlots.include3D ||
    options.trajectoryPlots.includeNorthing ||
    options.trajectoryPlots.includeEasting ||
    options.trajectoryPlots.includePlanView ||
    options.trajectoryPlots.includeDoglegSeverity;

  if (options.includeTrajectory && !hasAnyTrajectoryPlot) {
    errors.push('Select at least one trajectory plot when Trajectory is enabled');
  }

  return errors;
}
